import { HStack, Spacer, Stack, Box } from '@chakra-ui/react'
import { useParams, Outlet } from 'react-router-dom'

import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import ContextBreadcrumbs from '@app/pages/maps/components/contextBreadcrumbs'
import ContextHeader from '@app/pages/maps/components/contextHeader'
import ContextSection from '@app/pages/maps/components/contextSection'
import DeleteBusinessContextButton from '@app/pages/maps/components/deleteBusinessContextButton'
import FoldersSection from '@app/pages/maps/components/foldersSection'
import MapsSection from '@app/pages/maps/components/mapsSection'
import { ListFilterContextProvider } from '@app/pages/shared/listFilterContext'
import Can from '@app/shared/authorization/can'
import { PageStack } from '@app/shared/layout'
import withSuspenseWrapper from '@app/shared/withSuspenseWrapper'
import { useBusinessContextQuery } from '@graphql/queries'

const Show = () => {
  const { businessContextId } = useParams()

  // Root business context of /maps handling
  const filters = businessContextId ? { slug: businessContextId } : { parentBusinessContextSlug: null }

  const storeBusinessContext = useGetObjectsByProperties('businessContext', filters)

  const [{ data, fetching }] = useBusinessContextQuery({
    variables: { id: businessContextId }
  })

  const businessContext = storeBusinessContext?.[0] || data?.businessContext

  return (
    <PageStack>
      <Stack gap={2}>
        <Box borderBottomWidth={1} borderBottomStyle="solid" borderColor="border.default" borderRadius="xs" py={3}>
          <ContextBreadcrumbs businessContext={businessContext} loading={fetching} />
        </Box>

        <HStack>
          <ContextHeader businessContext={businessContext} />
          <Spacer />
          <Can I="delete" a="businessContext">
            <DeleteBusinessContextButton businessContext={businessContext} />
          </Can>
        </HStack>
        <Stack gap={6}>
          <ContextSection businessContext={businessContext} loading={fetching} />
          <FoldersSection businessContext={businessContext} loading={fetching} />
          <ListFilterContextProvider searchField="filter">
            <MapsSection businessContext={businessContext} loading={fetching} />
          </ListFilterContextProvider>
        </Stack>
        <Outlet />
      </Stack>
    </PageStack>
  )
}

export default withSuspenseWrapper(Show)
